<template>
  <div>
    <button @click="modalVisible = true" class="btn-ver-admins">
      Ver administradores
    </button>

    <!-- Modal -->
    <transition name="fade">
      <div v-if="modalVisible" class="modal-overlay">
        <div class="modal-content">
          <div class="modal-header">
            <h2>Administradores del grupo</h2>
            <button class="btn-cerrar-modal" @click="modalVisible = false">✕</button>
          </div>

          <div class="modal-body">
            <!-- Reutilizamos la lógica existente -->
            <div v-if="group.users.length > 0 && canView('superadministrador','administrador','administradorevento')">
              <table class="min-w-full divide-y divide-gray-200 table-users">
                <thead class="bg-gray-100">
                  <tr>
                    <th class="th-style">Usuario</th>
                    <th v-if="!fechaCorte" class="th-style">Acciones</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="user in group.users" :key="user.id">
                    <td class="px-4 py-3 text-left">
                      <div class="flex flex-col">
                        <span class="font-medium text-gray-900">{{ user.nombre }}</span>
                        <span class="text-sm text-gray-500">{{ user.email }}</span>
                      </div>
                    </td>
                    <td v-if="!fechaCorte && grupo_activo == 1" class="px-4 py-3">
                      <div class="flex flex-wrap items-center gap-2">
                        <EnvioMagicLinkUsuario
                          v-if="canView('superadministrador','administradorevento','administrador')"
                          :tokenUsuario="user.id_token"
                          :groupToken="group.group_id"
                        />
                        <button @click="editUser(user.id_token)" class="btn-action edit">Editar</button>
                        <button @click="deleteUser(user.id_token, group.group_id)" class="btn-action delete">Eliminar</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center py-2 text-gray-500 text-sm">
              <span v-if="canView('superadministrador','administrador')">Sin moderadores</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

  
<script>
import axios from 'axios';
import { useToast } from "vue-toastification";
import EnvioMagicLinkUsuario from '@/components/administracion/EnvioMagicLinkUsuario.vue';
export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
    fechaCorte: Boolean,
    grupo_activo: String
    // token: {
    //   type: String,
    //   required: true
    // }
  },
  components: {
    EnvioMagicLinkUsuario
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
        return {
            modalVisible: false,
            localFechaCorte: this.fechaCorte,
        };
    },

  inject: ['canView'], // Inyectar la función canView desde el componente padre
  methods: {
    editUser(userId) {
      const url = `/dashboard/user/edit/${userId}`;
      window.open(url, '_blank');
    },
    deleteUser(userId, groupId) {
    const token = this.$store.state.user.token;
      axios.post(`/api/user/delete/${userId}`, { grupo: groupId, Authorization: `${token}` })
      .then(response => {
        if (response.data && response.data.success) {
          this.toast.success(response.data.success);
          this.$emit('user-deleted', { userId, groupId }); // Emitir ambos IDs
        } else {
          this.toast.warning('Usuario eliminado, podria no reflejarse automaticamente');
        }
      })
      .catch(error => {
        console.error("Error al eliminar usuario:", error);
        let errorMessage = 'Error al eliminar usuario';
        if (error.response && error.response.data) {
          errorMessage = error.response.data.error || error.response.data.message || errorMessage;
        } else {
          errorMessage = error.message || errorMessage;
        }
        this.toast.error(errorMessage);
      });
    },
  }
}
</script>
<style lang="sass" scoped>
.table-users
  width: 100%
  border-collapse: collapse
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif

.th-style
  padding: 0.75rem 1rem
  text-align: left
  font-size: 0.75rem
  font-weight: 600
  color: #4b5563
  text-transform: uppercase
  background-color: #f3f4f6

.btn-action
  padding: 6px 12px
  font-size: 0.75rem
  font-weight: 500
  border-radius: 6px
  transition: background-color 0.2s ease, color 0.2s ease
  white-space: nowrap

.btn-action.edit
  background-color: #2563eb
  color: #fff

.btn-action.edit:hover
  background-color: #1d4ed8

.btn-action.delete
  background-color: #dc2626
  color: #fff

.btn-action.delete:hover
  background-color: #b91c1c

.btn-ver-admins
  background-color: #4b5563
  color: white
  font-size: 0.85rem
  padding: 8px 16px
  border-radius: 6px
  font-weight: 500
  margin-bottom: 1rem

.modal-overlay
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0, 0, 0, 0.6)
  display: flex
  align-items: center
  justify-content: center
  z-index: 1000

.modal-content
  background: white
  border-radius: 10px
  width: 90%
  max-width: 900px
  padding: 2rem
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2)
  position: relative
  max-height: 90vh
  overflow-y: auto

.modal-header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 1rem

.fade-enter-active, .fade-leave-active
  transition: opacity 0.3s ease

.fade-enter-from, .fade-leave-to
  opacity: 0


button 
  background: rgb(61, 67, 91)!important
  border-radius: 3px!important

.btn-cerrar-modal
  background: transparent!important
  border: none
  font-size: 1.25rem
  cursor: pointer
  color: #374151
  </style>